import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-variants',
  templateUrl: './stock-variants.component.html',
  styleUrls: ['./stock-variants.component.css']
})
export class StockVariantsComponent implements OnInit {
    functionName;

    prodId;

    public menu?: Menu;

    public itemsListStockVariantsOfProdIds: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.functionName = this.stateService.getStateParams()['functionname'];
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadMenu() {
        if (!!this.prodId) {
            this.menu = (await this.datatask.Post(463, { prod_id: this.prodId }))[0];
        }
    }

    private async loadtockVariantsOfProdIds() {
        if (!this.menu) return;

        return this.itemsListStockVariantsOfProdIds = await this.datatask.Post(464, {
            prod_id: this.menu.prod_id,
            stockplace_id: this.menu.stockplace_id,
            functionname: this.functionName,
            include_not_in_stock: this.menu.include_not_in_stock
        });
    }

    public onChanged(_: string, id: keyof Menu) {
        if (!this.menu) return;

        switch (id) {
            case 'include_not_in_stock':
                this.loadtockVariantsOfProdIds();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadtockVariantsOfProdIds();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    stockplace_id: string;
    stockplace_name: string;
    prod_id: string;
    prod_name: string;
    include_not_in_stock: string;
}
